// import autocomplete from '@/components/autocomplete/index.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  name: 'delivery-carrier',
  data() {
    return {
      town: '',
      townRef: '',
      department: '',
      city: '',
      zipCode: '',
      isValid: false,
      isValidTown: false,
      isValidDepartment: false,
      carrierList: [],
      filterCarrierList: [],
      building: '',
      flat: '',

      selectedCarrier: null,
      selectedCarrierRef: null,

      selectedBranch: null,

      carrierPickupPointList: [],
      filterCarrierPickupPointList: [],
      selectedPickupPointCarrier: null,
      selectedPickupPointCarrierRef: null,

      pickupPointList: [],
      filterPickupPointList: [],
      selectedPickupPoint: null,
      selectedPickupPointRef: null,
      selectedPickupPointCity: null,
      selectedPickupPointStreet: null,
      selectedPickupPointZip: null,
    }
  },
  props: {
    selectedCountry: {
      type: Object,
      default: null,
    },
  },
  components: {
    // autocomplete
  },
  computed: {
    ...mapGetters({
      towns: 'order/towns',
      departments: 'order/departments',
      isTownsLoading: 'order/isTownsLoading',
      isAddressLoading: 'order/isAddressLoading',
      cities: 'zasilkovna/cities',
      branches: 'zasilkovna/branches',
    }),
  },
  watch: {
    selectedCountry(val) {
      if (val) {
        this.loadCarriersForCountry(val)
      }
      this.saveDeliveryData()
    },
    selectedCarrier() {
      this.selectedPickupPoint = null
      this.selectedPickupPointRef = null
      this.saveDeliveryData()
    },
    selectedPickupPoint() {
      this.saveDeliveryData()
    },
  },
  created() {
    if (this.selectedCountry) {
      this.loadCarriersForCountry(this.selectedCountry)
    }
  },
  methods: {
    ...mapActions({
      fetchTowns: 'order/NOVA_POSHTA_GET_TOWNS',
      fetchDepartments: 'order/NOVA_POSHTA_GET_DEPARTMENS',
      fetchCity: 'zasilkovna/GET_CITY_LIST',
      fetchCountry: 'zasilkovna/GET_COUNTRIES_LIST',
      fetchCarriersList: 'zasilkovna/GET_CARRIER_PICKUP_POINTS_LIST',
      fetchBranch: 'zasilkovna/GET_BRANCH_LIST',
      fetchCarrierPickupPointList: 'zasilkovna/GET_CARRIER_PICKUP_POINTS_LIST',
      fetchPickupPointList: 'zasilkovna/GET_PICKUP_POINTS_LIST',
    }),
    ...mapMutations({
      setDepartments: 'order/NOVA_POSHTA_SET_DEPARTMENS',
      changeAddress: 'order/CHANGE_ADDRESS_COURIER',
      saveAddress: 'order/SAVE_DELIVERY_ADDRESS',
    }),

    loadCarriersForCountry(country) {
      this.selectedCarrier = null
      this.selectedCarrierRef = null
      this.selectedPickupPoint = null
      this.selectedPickupPointRef = null
      this.carrierList = []
      this.filterCarrierList = []
      this.getHandlerCarrier(country)
    },
    saveDeliveryData() {
      const countryName = this.selectedCountry?.name || null
      const countryCode = this.selectedCountry?.alpha2Code || null
      const data = {
        carrier: this.selectedCarrier,
        carrierRef: this.selectedCarrierRef,
        country: countryName,
        countryCode: countryCode,
        pickupPoint: this.selectedPickupPoint,
        pickupPointRef: this.selectedPickupPointRef,
        city: this.selectedPickupPointCity,
        street: this.selectedPickupPointStreet,
        zip: this.selectedPickupPointZip,
      }
      this.saveAddress(data)
      this.changeAddress(data)
    },
    getHandlerCarrier(country) {
      const payload = {
        country: country.alpha2Code,
        search: '',
        with_cod: false,
      }
      this.fetchCarriersList(payload)
        .then((res) => {
          this.carrierList = res
          this.filterCarrierList = res
          // console.log('fetchCarriersList ====> ', res);
        })
        .catch((error) => {
          console.log('fetchCarriersList ERROR ====> ', error)
        })
    },
    handleCarrierInput(e) {
      if (e.length < 3) {
        this.filterCarrierList = this.carrierList.slice()
        return
      }
      this.filterCarrierList = this.carrierList.filter((item) => item.name.toLowerCase().includes(e.toLowerCase()))
    },
    handlePickupPointInput: debounce(async function (e) {
      if (e.length < 3) {
        try {
          const response = await this.fetchPickupPointList({ carrierId: this.selectedCarrierRef, search: e })
          this.filterPickupPointList = response
          this.pickupPointList = response
        } catch (e) {
          console.error('handlePickupPointInput Error: ', e)
        }
        return
      }

      try {
        const response = await this.fetchPickupPointList({ carrierId: this.selectedCarrierRef, search: e })
        this.filterPickupPointList = response
      } catch (e) {
        console.error('handlePickupPointInput Error: ', e)
      }
    }, 300),

    async handleCarrierSelect(e) {
      this.selectedCarrierRef = e.id
      this.selectedCarrier = e.name
      this.$emit('select-carrier', {
        country: this.selectedCountry?.alpha2Code,
      })
      this.selectedBranch = ''
      try {
        this.pickupPointList = await this.fetchPickupPointList({ carrierId: e.id })
        this.filterPickupPointList = this.pickupPointList
      } catch (e) {
        console.error('handleCarrierSelect Error: ', e)
        this.$toasted.error(this.$t('somethingWentWrongTryAgainLater'))
      }
    },
    handlePickupPointSelect(e) {
      this.selectedPickupPointRef = e.code
      this.selectedPickupPoint = e.name
      this.selectedPickupPointCity = e.city || null
      this.selectedPickupPointZip = e.zip || null
      const combinedStreet = [e.street, e.streetNumber].filter(Boolean).join(' ').trim()
      this.selectedPickupPointStreet = combinedStreet || e.street || null
      this.$emit('select-carrier-pickup-points', e)
      this.selectedBranch = ''
    },
  },
}
